/* ==========================================================================
   Gutsi - homepage "Private, Precise, Powerful" band: the video element.
   Loaded from snippets/stylesheets.liquid with defer.
   Styling companion: assets/claude-privacy.css, which turns this into a
   full-bleed background and rules the band top and bottom.

   This file only creates the <video> and decides when it plays. Everything
   about how the band LOOKS is in the CSS.

   TO SWAP THE CLIP: upload to Shopify Files, open it, and take the .HD-720p-
   mp4 URL (not the .m3u8, not the /videos/c/o/v/ original). Replace SRC.

   CURRENT: "My Movie 2.mp4", uploaded 9 Sep 2026, 6.0s, 1920x1080 - a slow,
   near-static wide shot of a bathroom. It is pale from end to end, which is
   why the CSS carries a heavy scrim; a darker clip could take a lighter one.

   720p rather than 1080p on purpose: the band is at most ~580px tall, the
   clip is decorative and sits far enough down the page that most visits never
   reach it. 1080p would be wasted bytes on every load that does.
   ========================================================================== */

(function () {
  var SRC = 'https://cdn.shopify.com/videos/c/vp/bb89bf31dd8b4f43ad3ad1c48d86405a/bb89bf31dd8b4f43ad3ad1c48d86405a.HD-720p-3.0Mbps-93951795.mp4';

  function build() {
    var container = document.querySelector('.privacy-section__carousel-container');
    if (!container || container.querySelector('.claude-privacy-video')) return;

    var video = document.createElement('video');
    video.className = 'claude-privacy-video';
    video.src = SRC;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.preload = 'metadata';
    video.setAttribute('aria-hidden', 'true');
    video.tabIndex = -1;
    container.appendChild(video);

    /* Reduced-motion visitors get a still frame and no movement. The band
       still reads correctly - it is a photograph of a bathroom either way. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.loop = false;
      return;
    }

    function play() {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    /* Only decode while it is on screen. This band sits roughly 3,200px down
       the homepage, so the majority of visits never scroll to it. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            play();
          } else {
            try { video.pause(); } catch (e) {}
          }
        });
      }, { threshold: 0.15 }).observe(video);
    } else {
      play();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
